/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CompanyPartner,
    CompanyPartnerFromJSON,
    CompanyPartnerFromJSONTyped,
    CompanyPartnerToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyPartnersListResponse
 */
export interface CompanyPartnersListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof CompanyPartnersListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<CompanyPartner>}
     * @memberof CompanyPartnersListResponse
     */
    entries: Array<CompanyPartner>;
}

export function CompanyPartnersListResponseFromJSON(json: any): CompanyPartnersListResponse {
    return CompanyPartnersListResponseFromJSONTyped(json, false);
}

export function CompanyPartnersListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyPartnersListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(CompanyPartnerFromJSON)),
    };
}

export function CompanyPartnersListResponseToJSON(value?: CompanyPartnersListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(CompanyPartnerToJSON)),
    };
}


